<template>
    <div v-cloak>
        <div class="row">

            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'configuracion'}">{{$t("configuracion")}}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{$t("formasDePago")}}</li>
                    </ol>
                </nav>
            </div>

            <div class="col-md-12">
                <div class="card">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>{{$t("negocio")}}</label>

                                <el-select class="select-default"
                                           size="large"
                                           v-model="idBusiness"
                                           filterable
                                           :placeholder="$t('seleccionaNegocio')"
                                           @change="cambioNegocio()">
                                    <el-option v-for="business in listBusinesses"
                                               class="select-primary"
                                               :value="business.id"
                                               :label="business.establishmentName"
                                               :key="business.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <div v-if="listFormasPago.length>0 && respuesta && permiso" class="col-md-8 text-right">
                            <label> </label><br>
                            <el-dropdown>
                                <el-button type="primary" size="small">
                                    <i class="fa fa-file"></i>
                                    {{$t("exportarInforme")}} <i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <a :href="urlExportPDF">
                                        <el-dropdown-item class="text-danger">
                                            <strong><i class="fa fa-file-pdf"></i> {{$t("exportarPdf")}}</strong>
                                        </el-dropdown-item>
                                    </a>
                                    <a :href="urlExportExcel">
                                        <el-dropdown-item class="text-success">
                                            <strong><i class="fa fa-file-excel"></i> {{$t("exportarExcel")}}</strong>
                                        </el-dropdown-item>
                                    </a>
                                </el-dropdown-menu>
                            </el-dropdown>

                        </div>
                    </div>
                </div>
            </div>

            <template v-if="!permiso">
                <div class="alert alert-danger m-3" style="width: 100%" role="alert">
                    Lo sentimos. Este negocio no cuenta con este módulo activado.
                </div>
            </template>
            <div class="col-md-12" v-else-if="respuesta">
                <div class="card">

                    <div class="row">
                        <div class="col-md-8">
                            <div class="form-group">
                                <router-link :to="{name:'forma-de-pago', params:{'idBusiness':this.idBusiness}}">
                                    <button class="btn btn-primary"><i class="fa fa-plus-square"></i>
                                        {{$t("agregarFormaDePago")}}
                                    </button>
                                </router-link>
                            </div>
                        </div>

                        <div class="col-md-4 text-right">
                            <div class="input-group">
                                <input type="text" class="form-control" v-bind:placeholder="$t('buscar')"
                                       v-model="searchQuery"
                                       @keyup.enter.prevent="searchOperarios">
                                <div class="input-group-append">
                                    <button class="btn btn-secondary" type="button" @click="searchOperarios"><i
                                            class="fa fa-search"></i>
                                    </button>
                                    <button class="btn btn-secondary" type="button" @click="removeSearch"><i
                                            class="fa fa-times"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row" v-if="isSearch">
                        <div class="col-md-12">
                            <p>
                                <small>{{showResult}}</small>
                            </p>
                        </div>
                    </div>

                    <div class="table-responsive" v-if="listFormasPago.length > 0">
                        <table class="table table-bordered table-striped">
                            <thead class="thead-dark">
                            <tr>
                                <th>{{$t("nombre")}}</th>
                                <th>{{$t("tipo")}}</th>
                                <th>{{$t("acciones")}}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="fp in listFormasPago">
                                <td>
                                    <div>{{fp.name}}
                                        <span style="color: red" v-if="fp.baja=='1'">
                                            [{{$t("BAJA")}}]
                                        </span>
                                    </div>
                                </td>
                                <td>
                                    <div v-if="fp.tipo==='C'">{{$t("cheque")}}</div>
                                    <div v-else>{{$t("tarjeta")}}</div>
                                </td>
                                <td style="width: 70px; text-align: center">
                                    <router-link
                                            :to="{name:'forma-de-pago', params:{'idBusiness':idBusiness,'idFormaPago':fp.id, 'pag':pag}}">
                                        <a class="btn btn-danger btn-link btn-xs">
                                            <i v-tooltip.top-center="$i18n.t('editar')" class="fas fa-pencil-alt"
                                               style="color: orange"></i>
                                        </a>
                                    </router-link>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="alert alert-danger" role="alert" v-else>
                        {{$t("noHayFormasDePagoEnEsteNegocio")}}
                    </div>

                    <div class="row" v-if="!isSearch && totalPags > 1">
                        <div class="col-md-12">
                            <nav>
                                <ul class="pagination flex-wrap">
                                    <li class="page-item" :class="{'disabled':pag == 1}">
                                        <router-link class="page-link"
                                                     :to="{name: 'formas-de-pago', params: {pag: pag-1}}"
                                                     v-if="pag != 1">&laquo;
                                        </router-link>
                                        <span v-else class="page-link"><span aria-hidden="true">&laquo;</span></span>
                                    </li>
                                    <li class="page-item" v-for="n in totalPags" :class="{active : n == pag}">
                                        <router-link class="page-link" :to="{name: 'formas-de-pago', params: {pag:n}}">
                                            {{n}}
                                        </router-link>
                                    </li>
                                    <li class="page-item" :class="{'disabled':pag == totalPags}">
                                        <router-link class="page-link"
                                                     :to="{name: 'formas-de-pago', params: {pag: nextPag}}"
                                                     v-if="pag != totalPags">
                                            &raquo;
                                        </router-link>
                                        <span v-else class="page-link"><span aria-hidden="true">&raquo;</span></span>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {DatePicker, Select, Option, Dropdown, DropdownItem, DropdownMenu, Button} from 'element-ui'
    import {Loading} from 'element-ui';
    import swal from 'sweetalert2'
    import { mapState } from 'vuex'

    export default {
        created() {
            this.loadingGeneral = Loading.service({text: 'Cargando...'});
            this.$store.dispatch("setNameRoute", this.$i18n.t("formasDePago"));
            this.getBusiness();

            if (this.$store.getters.idBusiness) {
                this.idBusiness = this.$store.getters.idBusiness;
            }
        },
        components: {
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [Option.name]: Option
        },
        data() {
            return {
                loadingGeneral: null,
                loading: false,
                listBusinesses: [],
                listFormasPago: ["-"], // Pongo '-' para cuando cargue la vista no se vea el rojo de no hay elementos
                idBusiness: this.$route.params.idBusiness,
                searchQuery: this.$route.params.query,
                isSearch: false,
                pag: this.$route.params.pag,
                totalPags: 0,
                respuesta:true,
            }
        },
        watch: {
            '$route'(to, from) {
                if (to.params.pag) {
                    this.pag = to.params.pag;
                    this.getFormasPago();
                } else if (to.params.query) {
                    this.query = to.params.query;
                    this.getFormasPago();
                }
            }
        },
        computed: {
            ...mapState(["permiso"]),
            showResult() {
                if (this.listFormasPago.length == 0) {
                    return this.$t('noEncontramosResultadosPara') + this.searchQuery;
                } else {
                    const result = this.listFormasPago.length == 1 ? this.$t('resultado') : this.$t('resultados');
                    return this.$t('mostrando')+ " " + this.listFormasPago.length + " " + result;
                }
            },
            nextPag() {
                let nextPag = parseInt(this.pag) + 1;
                return nextPag;
            },
            urlExportPDF() {

                return "../api/public/index.php/formaspago/exportListFormaspago/PDF?idBusiness=" + this.idBusiness + "&jwt=" + this.$store.getters.jwt


            },
            urlExportExcel() {


                /*  return "../api/public/index.php/suppliers/exportGastosSupplier/Excel?idBusiness=" + this.idBusiness + "&procedencia=" + this.procedencia + "&idSupplier=" + this.idSupplier + "&datefrom=" + moment(this.datefrom).unix() + "&dateto=" + moment(this.dateto).unix() + "&jwt=" + this.$store.getters.jwt
                 */
                return "../api/public/index.php/formaspago/exportListFormaspago/Excel?idBusiness=" + this.idBusiness + "&jwt=" + this.$store.getters.jwt
            }
        },
        methods: {
            getBusiness() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
                    .then(function (response) {

                        if(response.data.response) {

                            if (!vm.idBusiness) {
                                vm.idBusiness = response.data.result[0].id;
                            }


                            vm.listBusinesses = response.data.result;
                            vm.getFormasPago();
                        }
                        else{
                            vm.loadingGeneral.close();
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            cambioNegocio() {

                this.pag = 1;
                this.totalPags = 0;

                this.getFormasPago();


            },
            getFormasPago() {

                const controller = this.searchQuery ? 'searchFormasPagoByName/' + this.searchQuery : 'getFormasPagoByBusiness';
                var config = {
                    params: {
                        pag: this.pag,
                        idBusiness: this.idBusiness,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                this.$store.dispatch("setIdBusiness", this.idBusiness);

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "formaspago/" + controller, config)
                    .then(function (response) {
                        if (response.data.response) {
                            vm.listFormasPago = response.data.result.formasPago;
                            vm.pag = response.data.result.pag;
                            vm.totalPags = response.data.result.totalPags;

                            vm.respuesta=true;
                            vm.loadingGeneral.close();
                        }
                        else {
                            vm.loadingGeneral.close();
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });

                            vm.respuesta=false;
                        }

//                        vm.loading.close();
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            searchOperarios() {
                if (this.searchQuery !== undefined && this.searchQuery !== "") {
                    this.$router.push({name: 'search-formas-de-pago', params: {query: this.searchQuery}});
                    this.isSearch = true;
                }
            },
            removeSearch() {
                if (this.searchQuery && this.searchQuery !== "") {
                    this.searchQuery = "";
                    this.isSearch = false;
                    this.$router.push({name: 'formas-de-pago'});
                    this.getFormasPago()
                }
            }
        }

    }
</script>

<style scoped>

    [v-cloak] {
        display: none;
    }

    tbody tr:hover {
        background-color: rgba(0, 153, 130, 0.2);
    }

    tbody td {
        padding: 0 !important;
    }

    td div {
        padding: 12px 8px;
        color: #333;
    }

    .buttonsSearch:hover {
        cursor: pointer;
        background-color: rgba(0, 153, 130, 0.1);
    }

    .card {
        padding: 20px;
    }

    .input-group button {
        height: 40px;
    }
</style>




// WEBPACK FOOTER //
// src/pages/Dashboard/Configuracion/FormasPago/FormasPago.vue